import React, { Component } from 'react'
import { Link } from 'react-router'
import { PropTypes } from 'prop-types'
import bem from '../../../common/bem'
import { isUrlExternal } from '../../../common/genericHelper'

import './Footer.scss'

export default class Footer extends Component {

  constructor() {
    super()
  }

  renderLinks({ bemmer }) {
    const { links, defaultFooter } = this.props
    const combinedLinks = links.concat(defaultFooter)

    return (
      <ul className={bemmer.element('links')}>
        { combinedLinks.map(content => <li key={`footer_${content.name}`}>
          {
            isUrlExternal(content.url) ? <a href={content.url} target="blank">{ content.name }</a> :
              <Link to={content.url ? content.url : '/'}>{ content.name }</Link>
          }
        </li>) }
      </ul>
    )
  }

  render() {

    const bemmer = bem('footer')

    return (
      <footer className={bemmer.element('container')}>
        <a className={bemmer.element('logo-reason')} href='https://reason.co'>
          <span>Made by the team at</span>
          <img
            src='/images/logo-reason.png'
            srcSet='/images/logo-reason.png 1x, /images/logo-reason@2x.png 2x, /images/logo-reason@3x.png 3x'
          />
        </a>
        { this.renderLinks({ bemmer }) }
        <a className={bemmer.element('logo-serverless')} href='https://serverless.com'>
          <img
            src='/images/logo-serverless.png'
            srcSet='/images/logo-serverless.png 1x, /images/logo-serverless@2x.png 2x, /images/logo-serverless@3x.png 3x'
            />
        </a>
      </footer>
    )
  }
}

Footer.propTypes = {
}

Footer.defaultProps = {
  links: [],
  defaultFooter: [
    {name: 'Github', url:'https://github.com/withreason'},
    {name: 'Twitter', url:'https://twitter.com/slszone'}
  ]
}



// WEBPACK FOOTER //
// ./component/ui/Footer/Footer.js